module.exports = __webpack_public_path__ + "img/chapter-2-thumb.aaab9540.jpg";